import { Action } from 'redux';
import { OrdiniActions } from './actionTypes';
import { statoOrdineFormatter } from './components/Formatters';
import { MatricolaCarrello, OrdineRiga, OrdiniState } from './models';

const initialState: OrdiniState = {
    destinatariMatricole: { lista: [], refreshCache: true },
    carrelloConsumabili: { lista: [] },
    ordini: { lista: [], page: 1, pageSize: 100, itemsCount: 0, refreshCache: true },
    consumabili: { lista: [], refreshCache: true }
}

export default (
    state: OrdiniState = initialState, 
    incomingAction: Action
): OrdiniState => {

    const action = incomingAction as OrdiniActions;
    switch (action.type) {
        case 'core/MODIFICA_ANAGRAFICA':
            return initialState;
        case 'core/SAVE_ANAGRAFICHE_CUSTOM':
        case 'core/SAVE_UBICAZIONI':
            return {
                ...state,
                destinatariMatricole: { ...state.destinatariMatricole, refreshCache: true }
            }
        case 'ordini/LOAD_DESTINATARI_MATRICOLE': 
            return { 
                ...state, 
                destinatariMatricole: { lista: action.value, refreshCache: false }
            };
        case 'ordini/LOAD_CONSUMABILI_MATRICOLA':
            return {
                ...state,
                consumabili: { lista: action.value, refreshCache: false }
            };
        case 'ordini/SVUOTA_CARRELLO':
            return {
                ...state,
                carrelloConsumabili: { lista: [] }
            };
        case 'ordini/LOAD_ORDINI':
            return {
                ...state,
                ordini: { 
                    lista: action.value.results, 
                    page: action.page, 
                    pageSize: action.value.pageSize,
                    itemsCount: action.value.count, 
                    refreshCache: false 
                }
            };
        case 'ordini/SAVE_ORDINE':
            return {
                ...state,
                ordini: { 
                    ...state.ordini,
                    refreshCache: true
                }
            };
        case 'ordini/ADD_CONSUMABILI_TO_CART': {
            const newCarrello = Array.from(state.carrelloConsumabili.lista);
            let carrelloMatricola = newCarrello.find((value) => value.matricola.idSpecifica === action.matricola.idSpecifica);

            if (carrelloMatricola === undefined) {
                carrelloMatricola = {
                    matricola: action.matricola,
                    righe: []
                };
                newCarrello.push(carrelloMatricola);
            } 

            if (carrelloMatricola.righe === undefined) {
                carrelloMatricola.righe = [];
            }

            action.dettagli.forEach(dettaglio => {
                if (carrelloMatricola!.righe.some(r => r.codice === dettaglio.codice)) {
                    carrelloMatricola!.righe.forEach(r => {
                        if (r.codice === dettaglio.codice)
                            r.quantita += dettaglio.quantita;
                        });
                }
                else {
                    carrelloMatricola!.righe.push(dettaglio);
                }
            });

            return {
                ...state,
                carrelloConsumabili: { lista: newCarrello }
            };
        }
        case 'ordini/RIMUOVI_CONSUMABILE_FROM_CART': {
            let newCarrello = Array.from(state.carrelloConsumabili.lista);
            let carrelloMatricola = newCarrello.find((value) => value.matricola.idSpecifica === action.idSpecifica);

            if (carrelloMatricola === undefined) {
                return {
                    ...state
                }
            }

            let righe: OrdineRiga[] = [];
            do {
                var riga = carrelloMatricola.righe.shift();
                if (riga !== undefined && riga.codice !== action.consumabile.codice) {
                    righe.push(riga);
                }
            } while (riga !== undefined);

            carrelloMatricola.righe = Array.from(righe);

            if (carrelloMatricola.righe.length === 0) {
                let tempCarrello: MatricolaCarrello[] = [];
                do {
                    var carrello = newCarrello.shift();
                    if (carrello !== undefined) {
                        if (carrello.matricola.idSpecifica !== action.idSpecifica) {
                            tempCarrello.push(carrello);
                        }
                    }
                } while (carrello !== undefined);

                newCarrello = Array.from(tempCarrello);
            }

            return {
                ...state,
                carrelloConsumabili: { lista: newCarrello }
            };
        }

        default: return state;
    }
};